import { CSSObject } from "@emotion/react";

import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;
const black = colors.ui.black[500];
const neutral400 = colors.ui.neutral[400];

const commonStyles: CSSObject = {
  color: black,
  margin: "8px 0",
  borderRadius: "8px",
  fontWeight: "bold",
  width: "100%",
  background: "transparent",
  // Avoid extra padding from generatePDF, which we're not sure if it's safe to
  // remove. Usually it's not a problem, but the font size here can be larger
  // than the padding added by the function
  padding: "1px 2px !important",
  ...typographyStyles.fontFamily.circular,
};

export const titleInputStyles = (
  align: "left" | "right" | "center" = "left",
): CSSObject => ({
  ...commonStyles,
  border: `1px solid ${neutral400}`,
  textAlign: align,
});

export const paragraphStyles = (
  align: "left" | "right" | "center" = "left",
): CSSObject => ({
  ...commonStyles,
  textAlign: align,
});
